import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEnvelope, faFileAlt, faTasks, faGlobe, faReply, faBell } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header"; 
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";     
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { withToken, withRFSToken } from '../../../Services/axios.js';
import { USERDELETE, AIRLINEUSER, AIRLINESTATION, AIRLINESAVEUSER, AIRLINEREMOVEUSER, } from '../../../Utils/conts.js';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { type } from 'jquery';
import MessageBox from '../../../Components/common/MessageBox.js';

const TemplateManagement = ({ isModal, ruleId }) => {

  const isMounted = useRef(false);
  const quillRef = useRef(null);
  const [modalShow, setModalShow] = useState(false);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const [rolestype, setRolestype] = useState([]);
  const [moduleType, setModuleType] = useState([]);
  const [userList, setUserList] = useState([]);
  const [activeTab, setActiveTab] = useState('email');
  const [days, setDays] = useState(30);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [showInsertModal, setShowInsertModal] = useState(false);
  const [insertFields, setInsertFields] = useState([]);
  const [cursorPosition, setCursorPosition] = useState(null);

  const gridRefs = {
    email: useRef(null),
    task: useRef(null),
    document: useRef(null),
  };
  const userRole = [
    { label: 'User', value: 'E' },
    { label: 'Admin', value: 'S' },
    // {label: 'Company Super Admin', value: 'SA'}
  ];
  const [disLoading, setDisLoading] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['image'],
      ['clean']
    ]
  };
  const iconMap = {
    63: <FontAwesomeIcon icon={faEnvelope} />,
    64: <FontAwesomeIcon icon={faFileAlt} />,
    65: <FontAwesomeIcon icon={faTasks} />,
    66: <FontAwesomeIcon icon={faGlobe} />,
    67: <FontAwesomeIcon icon={faReply} />,
    68: <FontAwesomeIcon icon={faBell} />
  };

  // const rolestype = [
  //   { label: "Compose an E-mail basedon the data", value: "1" },
  //   { label: "Document creation template", value: "2" },
  //   { label: "Define task linked to a Primary record", value: "3" },
  //   { label: "Documented webview template", value: "4" },
  //   { label: "Autometic Response E-mail", value: "5" },
  //   { label: "Notification E-mail", value: "6" },

  // ];

  const assignType = [
    { label: "Headoffice", value: "headoffice" },
    { label: "IT HYD", value: "It_hyd" },
    { label: "IT KOL", value: "It_kol" },
    { label: "IT Support", value: "It_support" },

  ];
  const overdueType = [
    { label: "Every day after due date", value: "eveyDay" },
    { label: "Every 3 days after due date", value: "3days" },
    { label: "Every week after due date", value: "week" },
    { label: "Every 30 days", value: "30days" },

  ];

  const senderContact = [
    { label: "CargoHub Cloud Service", value: "CCS" },
    { label: "CargoHub Support", value: "CS" },
    { label: "CargoHub Technical", value: "CT" },
  ];

  const triggerType = [
    { label: "New record recive", value: "new_record" },
    { label: "disable response", value: "disable" },
  ];

  const handleAddButtonClick = () => {
    setModalShow(true);
  };
  const handleEditButtonClick = (userId) => {
    setEditId(userId);
    setModalShow(true, { id: userId });
  };
  const handleModalClose = () => {
    setModalShow(false);
    setFormData({});
    setEditId('');

  };

  const [gridData, setGridData] = useState([]);
  const [stationList, setStationList] = useState([]);
  const fetchStation = async () => {
    try {
      const res = await withRFSToken.post(AIRLINESTATION, { status: 'A' })
        .then(function (res) {
          const innerData = res.data.Rows;
          // setGridData(innerData);
          const transformData = innerData ? innerData.map((item) => ({
            label: item.station_code,
            value: item.station_code
          })) : []
          setStationList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchData = async () => {
    try {
      const res = await withRFSToken.get('template/list')
        .then(function (res) {
          // if (res.data.response_code === 200) {
          const innerData = res.data.Rows;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.code,
          //   label: item.code +'-'+ item.name
          // })) : [];    
          setGridData(innerData);
        });
      // } else {
      //   toast.error(res.data.response_msg)
      // }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // -------------------fetch role----------------------

  const fetchRoles = async () => {
    try {
      const res = await withRFSToken.get('/template/roles');

      if (res.data.response_code === 200) {
        const dataWithIcons = res.data.response_data.map(item => ({
          ...item,
          icon: iconMap[item.value] || null
        }));

        setRolestype(dataWithIcons);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // ---------------end fetch role----------------------

  //----------------------fetch Module----------------------
  const fetchModules = async () => {
    try {
      const res = await withRFSToken.get('/template/modules')
        .then(function (res) {
          if (res.data.response_code === 200) {
            setModuleType(res.data.response_data);
            // console.log("🚀 ~ fetchModules ~ res.data.response_data:", res.data.response_data);
          }
        });


    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //-----------------end fetch Module----------------------

  const fetchuserData = async () => {
    try {
      const res = await withRFSToken.get('uld-setting/get-user-list')
        .then(function (res) {
          console.log("API user rows:", res.data.Rows);
          const options = res.data.Rows.map(user => ({
            label: `${user.first_name} ${user.last_name} `,
            value: user.user_id
          }));
          setUserList(options);

        });
      console.log("userList", userList);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchinsertData = async (mname) => {
    try {
      const res = await withRFSToken.post('template/get-insert-fields', { module: mname })
        .then(function (res) {
          console.log("Insert fields API response:", res.data);
          if (res.data.response_code === 200) {
            const innerData = res.data.response_data;
            if (innerData.length) {
              setInsertFields(res.data.response_data);
            } else {
              setInsertFields([]);
            }
            // } else if (res.data.Rows) {
            //   setInsertFields(res.data.Rows);
            //  } else {
            //   setInsertFields(res.data.response_data || []);
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleTabChange = async (tab) => {
    setActiveTab(tab);


    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'email') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ email: {} });
      }, 1);
    } else if (tab == 'task') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ task: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ document: {} });
      }, 1);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    fetchData();
    fetchStation();
    fetchRoles();
    fetchModules();
    fetchuserData()
    isMounted.current = true;
  }, []);

  const gridRef = useRef(null);
  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (!gridRefs[activeTab]?.current) return;

    const gridEl = window.$(gridRefs[activeTab].current);
    const token = "Bearer " + localStorage.airlinetoken;

    let tabType = activeTab
    const source = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'string' },
        { name: 'template_title', type: 'string' },
        { name: 'role', type: 'string' },
        { name: 'module', type: 'string' },
        { name: 'module_label', type: 'string' },
        { name: 'due_date', type: 'string' },
        { name: 'description', type: 'string' },
        { name: 'locator_key', type: 'string' },
        { name: 'sender_contact', type: 'string' },
        { name: 'due_date_after', type: 'string' },
        { name: 'automatic_assign', type: 'string' },
        { name: 'overdue_notif', type: 'string' },
        { name: 'triggering_event', type: 'string' },
        { name: 'responder_contact', type: 'string' },
        { name: 'content', type: 'string' },
        { name: 'role_label', type: 'string' },
      ],
      id: `${activeTab}-`,
      url: `${process.env.REACT_APP_RFS_URL}template/list?tab=${tabType}`,
      beforeSend: function (jqXHR) {
        jqXHR.setRequestHeader('Authorization', token);
      },
      pagesize: 50,
      filter: function (allfilters) {
        setFilterApplied(allfilters.length > 0);
        filterForCheck = allfilters.length > 0;
        gridEl.jqxGrid('clearselection');
        gridEl.jqxGrid("updatebounddata", "filter");
      },
      beforeprocessing: function (data) {
        source.totalrecords = data.TotalRows;
      },
      sort: function () {
        gridEl.jqxGrid("updatebounddata", "sort");
      },
      root: "Rows",
      cache: false,
    };

    const dataAdapter = new window.$.jqx.dataAdapter(source);

    const columns = [
      {
        text: 'Actions',
        cellsrenderer: function () {
          return `
          <div class="grid_actions">
            <img src="${edit}" class="row_edit" />
            <img src="${trash}" class="row_delete" />
          </div>`;
        },
        width: '7%',
      },
      { text: 'Template Title', filtertype: 'textbox', datafield: 'template_title', width: '18%' },
      { text: 'Template Type', filtertype: 'textbox', datafield: 'role_label', width: '18%' },
      { text: 'Ceated On', filtertype: 'textbox', datafield: 'description', width: '10%' },
    ];

    const gridOptions = {
      width: '100%',
      source: dataAdapter,
      columns,
      autoheight: true,
      sortable: true,
      altrows: false,
      enabletooltips: true,
      editable: false,
      pageable: true,
      pageSize: 10,
      pagerButtonsCount: 10,
      pagerMode: 'advanced',
      filterable: true,
      filterrowheight: 45,
      showfilterrow: true,
      rowsheight: 50,
      columnsheight: 45,
      rendergridrows: params => params.data,
      rendered: function () {
        const rows = gridEl.jqxGrid('getrows');
        (checkUlds || []).forEach(uldNumber => {
          rows.forEach((element, index) => {
            if (element.uld_number === uldNumber) {
              gridEl.jqxGrid('selectrow', index);
            }
          });
        });
      },
    };


    gridEl.jqxGrid(gridOptions);


    gridEl.find('.jqx-grid-column-header').css('background-color', 'white');


    gridEl.off('click', '.row_edit');
    gridEl.off('click', '.row_delete');


    gridEl.on('click', '.row_edit', function () {
      const rowIndex = window.$(this).closest('[role="row"]').index();
      const rowData = gridEl.jqxGrid('getrowdata', rowIndex);
      if (!rowData) return;

      setEditId(rowData.id);
      setModalShow(true);
      setDays(rowData.due_date_after ? parseInt(rowData.due_date_after) : 30);

      setFormData({
        id: rowData.id || '',
        template_title: rowData.template_title || '',
        description: rowData.description || '',
        locator_key: rowData.locator_key || '',
        sender: rowData.sender_contact || '',
        due_date_after: rowData.due_date_after || 30,
        assgn: rowData.automatic_assign || '',
        overdue: rowData.overdue_notif || '',
        triggering_event: rowData.triggering_event || '',
        responder_contact: rowData.responder_contact || '',
        template_content: rowData.content || '',
        role_type:
          rolestype.find(
            r =>
              String(r.value) === String(rowData.role) ||
              String(r.label) === String(rowData.role_label)
          ) || null,
        module:
          moduleType.find(
            m =>
              String(m.value) === String(rowData.module) ||
              String(m.label) === String(rowData.module_label)
          )?.value || '',
      });
    });

    // Delete handler
    gridEl.on('click', '.row_delete', function () {
      const rowIndex = window.$(this).closest('[role="row"]').index();
      const rowData = gridEl.jqxGrid('getrowdata', rowIndex);
      if (!rowData) return;

      setDeleteId(rowData.id);
      handleShowConfirmation(deleteRow);
    });

    // Cleanup on unmount or when gridData changes
    return () => {
      gridEl.off('click', '.row_edit');
      gridEl.off('click', '.row_delete');
    };
  }, [gridData, activeTab]);


  const [formData, setFormData] = useState({
    // task_type: 'gfsdsfdg'
  });

  const handleChange = (name, value) => {
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };

  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };

    if (!validateEmail(formData.email)) {
      console.log('Invalid email address');
      toast.error('Invalid email address');
      isValid = false;
    }


    else {
      return isValid;
    }
  };

  const handleShowConfirmation = (deleteFunction) => {
    setShowConfirmation(true);
    setDeleteFunction(() => deleteFunction);
  };
  const handleConfirmDelete = () => {
    // deleteRow(gridSelect);
    // deleteFunction(deleteId)
    deleteRow();
    setShowConfirmation(false);

  };

  const handleCancelDelete = () => {
    setDeleteId('')
    setShowConfirmation(false);
  };
  const deleteRow = async (selectedId) => {
    try {
      const res = await withRFSToken.post("template/delete-restore", { id: deleteId });
      if (res.data.response_code == 200) {
        toast.success('User Data Removed Successfully')
        window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
        setDeleteId('');
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };

  const handleEditSave = async () => {
    if (!formData.role_type?.value) {
      toast.error('Please select Template Type');
      return;
    }

    if (!formData.template_title?.trim()) {
      toast.error('Template Title is required');
      return;
    }
    const payload = {
      id: editId,
      module: formData.module,
      role: formData.role_type?.value,
      template_title: formData.template_title,
      description: formData.description,
      locator_key: formData.locator_key,
      sender_contact: formData.sender,
      due_date_after: days,
      automatic_assign: formData.assgn,
      overdue_notif: formData.overdue,
      triggering_event: formData.trigger,
      responder_contact: formData.responder_contact,
      content: formData.template_content || '',
    };
    console.log("🚀 ~ handleEditSave ~ payload:", payload);
    // return false;
    try {
      const res = await withRFSToken.post("template/add-update", payload)
        .then(function (res) {
          if (res.data.response_code == 200) {
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            toast.success(res.data.response_msg)
            setModalShow(false)
          } else {
            toast.error(res.data.response_msg);
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }


  }

  const handleSliderChange = (e) => {
    setDays(parseInt(e.target.value));
  };

  const handleModuleChange = async (selected) => {
    setFormData(prev => ({
      ...prev,
      module: selected ? selected.value : ''
    }));

    if (selected) {
      fetchinsertData(selected.value)
    }
  };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* {console.log('formData', formData)} */}
      {/* <div className="">{console.log('delete id ', deleteId)}
        <Header logo_url={SBack ? SBack : '/Dashboard'} sBackUrl={SBack ? SBack : '/Dashboard'} />
        <div className="main-panel">

          <div className="row">
            <LeftSettings mode='HSA' /> */}

            <div className='col-9 col-xxl-9 stting_right'>
              <div className='settingbg_right'>
                <h4>Template Management</h4>
                <p>Lorem ipsum dolor sit amet, consectetur</p>
                <div className='d-flex justify-content-between'>
                  <div>
                    <Button variant="primary createplan" onClick={handleAddButtonClick} >
                      <FontAwesomeIcon icon={faPlus} /> Create Template
                    </Button>
                  </div>
                </div>
                {/* <div ref={gridRef} className='bookinggrid userstting'></div> */}
                <Tabs id="station-tabs" activeKey={activeTab} onSelect={(tab) => { setActiveTab(tab); handleTabChange(tab); }} className="booking_tab">
                  <Tab eventKey="email" title={<span>Email</span>} className='moveto'>
                    {!isLoading && (
                      <>
                        {filterApplied && (
                          <div className='clear_filter'>
                            <Button onClick={resetFilters}>Reset Filters</Button>
                          </div>
                        )}
                        <div ref={gridRefs.email} className='staion_grid'></div>
                      </>
                    )}
                  </Tab>

                  <Tab eventKey="task" title={<span>Task</span>} className='moveto'>
                    {filterApplied && (
                      <div className='clear_filter'>
                        <Button onClick={resetFilters}>Reset Filters</Button>
                      </div>
                    )}
                    {!isLoading && <div ref={gridRefs.task} className='staion_grid'></div>}
                  </Tab>
                  <Tab eventKey="document" title={<span>Doc</span>} className='moveto'>
                    {filterApplied && (
                      <div className='clear_filter'>
                        <Button onClick={resetFilters}>Reset Filters</Button>
                      </div>
                    )}
                    {!isLoading && <div ref={gridRefs.document} className='staion_grid'></div>}
                  </Tab>
                </Tabs>
              </div>
            </div>
          {/* </div> */}
          <Modal show={modalShow} centered onHide={handleModalClose} className='add_task_modal' size='xl' >
            <Modal.Header closeButton>
              <Modal.Title>
                <h6>
                  {editId &&
                    !editId == '' ? (
                    <>
                      Edit Template
                    </>
                  ) : (
                    <>
                      Create Template
                    </>
                  )
                  }
                </h6>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className='add_taskForm'>

                <Form.Group as={Row} className="mb-1" controlId="dropdown">
                  <Col sm='6'>
                    <Form.Label>Template Type <span style={{ color: 'red' }}>*</span> </Form.Label>

                    <Select
                      options={rolestype}
                      onChange={(selected) => setFormData(prev => ({ ...prev, role_type: selected }))}
                      placeholder="Select roles"
                      className=''
                      name="role_type"
                      value={formData.role_type || null}
                      formatOptionLabel={(option) => (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {option.icon}
                          <span>{option.label}</span>
                        </div>
                      )}
                    />
                  </Col>
                  <Col sm="6">
                    <Form.Label>All Modules</Form.Label>
                    <Select
                      options={moduleType}
                      onChange={handleModuleChange}
                      placeholder="Module"
                      className="down_selct"
                      name="module"
                      value={moduleType.find(option => option.value === formData.module) || null}
                    />
                  </Col>
                </Form.Group>



                {/* <Form.Group controlId="dropdown" className='mb-3' as={Row}>
                 

                  <Col sm="6">
                    <Form.Label>Module</Form.Label>
                    <Select
                      options={moduleType}
                      onChange={handleModuleChange}
                      placeholder="Module"
                      className="down_selct"
                      name="module"
                      value={moduleType.find(option => option.value === formData.module) || null}
                    />
                  </Col>


                </Form.Group> */}
                <Form.Group as={Row} className='mt-2'>
                  <Col sm="6">
                    <Form.Label> Title/Subject</Form.Label>
                    <Form.Control type="text" name='template_title' placeholder="Add Template Title" value={formData.template_title} onChange={(e) => handleChange('template_title', e.target.value)} />
                  </Col>
                  <Col sm="6">
                    <Form.Label> Description</Form.Label>
                    <Form.Control type="text" name='description' placeholder="Add Description" value={formData.description} onChange={(e) => handleChange('description', e.target.value)} />
                  </Col>

                </Form.Group>


                {/* {formData.role_type?.sl_no !== "3" && formData.role_type?.sl_no !== "1" && formData.role_type?.sl_no !== "5" && (
                <Form.Group className="mb-2" as={Row}>
                  <Col sm={6}>
                    <Form.Label>Locator Key</Form.Label>
                    <Form.Control
                      type="text"
                      name="locator_key"
                      placeholder=""
                      value={formData.locator_key}
                      onChange={(e) =>
                        handleChange("locator_key", e.target.value)
                      }
                    />
                  </Col>


                  <Col sm={4}>
                    <Form.Label>Sender Contact</Form.Label>
                    <Select
                      options={senderContact}
                      onChange={selected => setFormData(prev => ({ ...prev, sender: selected ? selected.value : '' }))}
                      placeholder="Sender Contact"
                      className="down_selct"
                      name="sender"
                      value={senderContact.find(option => option.value === formData.sender) || null}
                    />
                  </Col>


                  <Col sm={2} className="d-flex align-items-end">
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          locator_key: "",
                          sender: ""
                        }));
                      }}
                    >
                      Clear
                    </Button>
                  </Col>
                </Form.Group>
              )} */}
                {/* {console.log('userList',userList)} */}
                {formData.role_type?.sl_no == 2 && (
                  <>
                    <Form.Group as={Row} className="mb-3 mt-2" controlId="dueDays">
                      <Col sm="6">
                        <Form.Label>Autometic Assign</Form.Label>
                        <Select
                          options={userList}
                          onChange={selected => setFormData(prev => ({ ...prev, assgn: selected ? selected.value : '' }))}
                          placeholder="Select User"
                          className=""
                          name="assgn"
                          value={userList.find(option => option.value == formData.assgn) || null}
                          isClearable
                        />
                      </Col>
                      <Col sm='6'>
                        <Form.Label>Overdue notif</Form.Label>
                        <Select
                          options={overdueType}
                          onChange={selected => setFormData(prev => ({ ...prev, overdue: selected ? selected.value : '' }))}
                          placeholder=" Select Assign Type"
                          className=""
                          name="overdue"
                          value={overdueType.find(option => option.value === formData.overdue) || null}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="align-items-center" controlId="dueDays">
                      <Form.Label column sm="2">
                        Due date after:
                      </Form.Label>
                      <Col sm="1" style={{ marginLeft: '-75px' }}>
                        <Form.Control
                          type="number"
                          value={days}
                          min={0}
                          max={730}
                          onChange={handleSliderChange}
                          style={{ width: '65%' }}
                        />
                      </Col>
                      <Col sm="1" style={{ marginLeft: '-35px' }}>
                        <span>days</span>
                      </Col>
                      {/* <Col sm="8">
                        <Form.Range
                          value={days}
                          min={0}
                          max={730}
                          step={1}
                          onChange={handleSliderChange}
                        />
                      </Col> */}
                    </Form.Group>

                  </>

                )}

                {formData.role_type?.sl_no == 5 && (
                  <>
                    <Form.Group as={Row} className='mb-2'>
                      <Col sm="6">
                        <Form.Label>Triggering event</Form.Label>
                        <Select
                          options={triggerType}
                          onChange={selected => setFormData(prev => ({ ...prev, trigger: selected ? selected.value : '' }))}
                          placeholder="select trigger type"
                          className="down_selct"
                          name="trigger"
                          value={triggerType.find(option => option.value === formData.trigger) || null}
                        />
                      </Col>
                      <Col sm="6">
                        <Form.Label>Responder contact</Form.Label>
                        <Select
                          options={userList}
                          onChange={selected => setFormData(prev => ({ ...prev, responder_contact: selected ? selected.value : '' }))}
                          placeholder="select responder contact"
                          className="down_selct"
                          name="responder_contact"
                          value={userList.find(option => option.value === formData.responder_contact) || null}
                        />
                      </Col>

                    </Form.Group>
                  </>

                )}

                <div className='text-end mt-3'>
                  <button type="button" class="btn btn-primary" onClick={() => {
                    if (quillRef.current) {
                      const editor = quillRef.current.getEditor();
                      const selection = editor.getSelection();
                      setCursorPosition(selection ? selection.index : editor.getLength());
                    }
                    setShowInsertModal(true);
                  }}>Add insert</button>
                </div>

                <Form.Group className='mb-2' as={Row}>
                  <MessageBox
                    message_area="template"
                    value={formData.template_content || ''}
                    onMessageChange={content => setFormData(prev => ({ ...prev, template_content: content }))}
                  />
                </Form.Group>
              </Form>

            </Modal.Body>
            <Modal.Footer>
              <div className='d-flex justify-content-center mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => setModalShow(false)}>
                  Discard
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  Save
                </Button>
              </div>

            </Modal.Footer>
          </Modal>
          <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <h2>Confirm Delete</h2>
              <p>If you proceed with the change, Template data will be removed.
                Are you sure you want to continue?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCancelDelete}>
                No
              </Button>
              <Button variant="primary" onClick={handleConfirmDelete}>
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        {/* </div>
      </div> */}
      <Modal show={showInsertModal} onHide={() => setShowInsertModal(false)} centered size="lg" style={{ zIndex: 9999 }} className='insertmodel'>
        <Modal.Header closeButton>
          <Modal.Title>Insert Fields</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {insertFields && insertFields.length > 0 ? (
            <div className="insert-fields-container">
              <p>Click on a field to insert it into your template:</p>
              <div className="row">
                {insertFields.map((field, index) => (
                  <div key={index} className="col-md-6 mb-2">
                    <Button
                      variant="outline-primary"
                      className="w-100 text-start"
                      onClick={() => {
                        if (quillRef.current) {
                          const editor = quillRef.current.getEditor();
                          const position = cursorPosition !== null ? cursorPosition : editor.getLength();
                          const fieldText = `{{${field.value}}} `;

                          // Get current content and insert at position
                          const delta = editor.getContents();
                          editor.deleteText(position, 0);
                          editor.insertText(position, fieldText);

                          // Update cursor position for next insert
                          const newPosition = position + fieldText.length;
                          editor.setSelection(newPosition, 0);
                          setCursorPosition(newPosition);

                          // Focus back to editor
                          editor.focus();
                        } else {
                          const currentContent = formData.template_content || '';
                          setFormData(prev => ({
                            ...prev,
                            template_content: currentContent + `{{${field.value}}} `
                          }));
                        }
                      }}
                    >
                      {field.label || field.value}
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p>No insert fields available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInsertModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default TemplateManagement;